/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cost_Calc_ConfigureInputs */



/**
* | output |
* | --- |
* | "Configure your plan" |
*
* @param {Cost_Calc_ConfigureInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cost_calc_configure = /** @type {((inputs?: Cost_Calc_ConfigureInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cost_Calc_ConfigureInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Konfigurieren Sie Ihren Plan")
	return /** @type {LocalizedString} */ ("Configure your plan")
});